import type { Language, UserProfile } from '@/types';

export interface State {
    user: UserProfile | null;
    languages: Language[];
}

export const state: State = {
    user: null,
    languages: [],
};
